import { Builder } from '@builder.io/react'

import { HTMLRendererDefaults } from '@src/components/HTMLRenderer/HTMLRenderer.defaults'

import { HTMLRenderer } from './HTMLRenderer'

Builder.registerComponent(HTMLRenderer, {
  name: 'HTMLRenderer',
  friendlyName: 'HTMLRenderer',
  inputs: [
    {
      name: 'srcDoc',
      friendlyName: 'HTML content',
      type: 'code',
      defaultValue: HTMLRendererDefaults.srcDoc,
    },
  ],
})
